import { Question } from '../../question.class';
import { times, last } from 'lodash';

export function populateEmptyNumberOptions(question: Question, type = 'number', data:{[key:string]:any} = {}) {
  let diff =
    2 - question.options.filter(o => o.type === type && !o.text).length;
  if (diff > 0) {
    // add empty options
    times(Math.abs(diff), () => {
      let pos = question.options.filter(o => o.type === type).length;
      let option = question.addOption({ ...data, type, priority: pos }, { push: 'none' });
    });
  } else if (diff < 0) {
    // remove excess empty options
    times(Math.abs(diff), () => {
      let emptyOption = last(
        question.options.filter(o => o.type === type && !o.text)
      );
      question.deleteOptions({ id: emptyOption.id }, { push: 'none' });
    });
  }
  if (Math.abs(diff) > 0) question.notifyChangeThruTree([]);
}
